import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import hiddenDom from '../../components/hiddenDom.vue';
import observeDom from '../../components/observeDom.vue';
import microFeed from '../../components/microFeed/index.vue';
import couponCard from '../../components/couponCard.vue';
import couponListCard from '../../components/couponListCard/index.vue';
import relatedSearch from '../../components/relatedSearch.vue';
import poiLine from '../poiLine.vue';
import microBottomList from '../../components/microBottomList/index.vue';
import hotInfo from '../hotInfo.vue';
import operateDom from '../operateActivity/components/operateDom.vue';
import poiCard from '../poiCard.vue';
import poiOldFriend from '../poiOldFriend.vue';
import consultsCard from '../consultsCard.vue';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
import { isWeiXin, isBaiduMap, addPvNew, isBaiduMapAuto, isHarmony } from '../../../../utils';
import { usePushComponent } from '../../pushConfig';
import { showFeedBury } from '../../bury';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'MicroNote',
  components: {
    'hidden-dom': hiddenDom,
    'observe-dom': observeDom,
    microFeed,
    couponCard,
    couponListCard,
    relatedSearch,
    microBottomList,
    poiLine,
    hotInfo,
    operateDom,
    poiCard,
    poiOldFriend,
    consultsCard
  },
  props: {
    microIndex: {
      type: Number,
      default: 0
    },
    jumpWxAppUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      noteStyle: 'Micro',
      isBaiduMap: isBaiduMap(),
      isWeiXin: isWeiXin(),
      isBaiduMapAuto: isBaiduMapAuto(),
      isHarmony: isHarmony()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters('url', ['urlParams', 'abtest', 'source', 'firstUnique_id', 'dataType'])), mapGetters('dataList', ['dataList', 'showSpaceCompressFoldPart'])), {}, {
    newBtnIcon() {
      // 实验组使用新icon和文案，未命中实验则保持线上
      return this.abtest.includes('106722');
    },
    searchBtnIcon() {
      // 实验组显示跳起始页入口
      return this.abtest.includes('107018');
    },
    cloudControl() {
      return sessionStorage.getItem('cloud_control');
    },
    // 是否展示笔记
    visibleMicroFeed() {
      const {
        microIndex,
        source,
        feedInfo
      } = this;
      return microIndex > 0 || !usePushComponent(feedInfo.tpSource, source) && feedInfo && feedInfo.aiPush !== 'ai_tourist_guide';
    },
    feedInfo() {
      const feedItemInfo = this.dataList && this.dataList[this.microIndex] || {};
      return feedItemInfo;
    },
    adsInfo() {
      const {
        body: {
          ads_info = {}
        } = {}
      } = this.dataList && this.dataList[this.microIndex] || {};
      return ads_info;
    },
    isEmpty() {
      var _this$adsInfo;
      return ((_this$adsInfo = this.adsInfo) === null || _this$adsInfo === void 0 ? void 0 : _this$adsInfo.type) === 'ads_banner';
    },
    /**
     * 是否展示留咨条
     */
    isShowConsultsCard() {
      const {
        body: {
          ads_info = {}
        } = {}
      } = this.feedInfo || {};
      const {
        ext: {
          basic_ques_list_json = ''
        } = {
          basic_ques_list_json: '',
          phone: ''
        },
        type = ''
      } = ads_info || {
        ext: {}
      };
      return type === 'ads_zhuangxiu_banner' && basic_ques_list_json;
    },
    isShowCoupon() {
      return !this.isBaiduMapAuto && !this.poiCardLink && !this.isEmpty && !this.isShowBanner && !this.isShowConsultsCard;
    },
    isShowCouponCard() {
      return this.feedInfo.showSku && this.isShowCoupon;
    },
    isShowCouponListCard() {
      return this.feedInfo.skuListShow && this.isShowCoupon;
    },
    hotInfoShow() {
      return this.abtest.includes('107968');
    },
    isHotspotShow() {
      const {
        feedInfo: {
          hotspot = {}
        } = {}
      } = this;
      return hotspot && Object.keys(hotspot).length > 0;
    },
    isShowHiddenDom() {
      return this.microIndex > 0;
    },
    poiCardLink() {
      var _this$feedInfo;
      return (_this$feedInfo = this.feedInfo) === null || _this$feedInfo === void 0 || (_this$feedInfo = _this$feedInfo.mentioned) === null || _this$feedInfo === void 0 ? void 0 : _this$feedInfo.merge_map_url;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations({
    'setSpaceCompressFoldPart': 'dataList/setSpaceCompressFoldPart'
  })), {}, {
    // 使用push模版
    usePushNote(tp, source) {
      return usePushComponent(tp, source);
    },
    // 相关推荐
    relatedMentioned(item) {
      const {
        mentioned = {}
      } = item || {};
      const {
        content = []
      } = mentioned;
      return content.length > 0 && content[0].recommend_info || false;
    },
    // 单篇笔记埋点
    titleShow(index) {
      // 首篇笔记一定会曝光，非首篇走hiddendom的曝光上报
      if (index > 0) {
        showFeedBury(index);
      }
    },
    updateWxShare(val) {
      this.$emit('open-share', val);
    },
    // 跳转到地图
    jumpToMap() {
      this.$emit('jumpToMap');
    },
    // 相关搜索
    searchClick(url) {
      // 相关搜索点击埋点
      this.searchPV('click');
      openUrlByOpenApi(url);
    },
    // 相关搜索展示埋点
    showSearchPV() {
      this.searchPV('show');
    },
    // 相关搜索埋点
    searchPV(type) {
      addPvNew([`MCEDse.NewMedia.detailspage.relatesearch.${type}`], {
        unique_id: this.firstUnique_id,
        std_tag: this.urlParams.stdTag
      });
    },
    contentOpen() {
      // 展开操作发生在第一条自动展开之前时，把收起的内容展开
      if (!this.showSpaceCompressFoldPart) {
        this.setSpaceCompressFoldPart(true);
      }
    }
  })
};